<template>
    <startpage-modern v-if="view === 'modern'" :categories="categories" :mainbody="mainbody" :heading="heading"/>
    <startpage-classic v-else :categories="categories" :mainbody="mainbody"/>
</template>

<script>
import StartpageClassic from './startpageClassic.vue';
import startpageModern from './startpageModern.vue';

export default {
    components: {startpageModern, StartpageClassic},
    props: ['categories', 'mainbody', 'view', 'heading'],
    data() {
        return {
            items: this.categories.filter(cat => !cat.hideStartpage)
        };
    }
};
</script>
